<article data-homeComponent class="flex flex--cols-3">
  <section class="flex-child flex-child--align-top">
    <h1 class="h1">
      {{ "home.content.left.text.welcome.title" | translate | async }}
    </h1>
    <p>
      {{ "home.content.left.text.welcome.content" | translate | async }}
    </p>
  </section>
  <section class="flex-child flex-child--align-top">
    <h2 class="h2">
      {{ "home.content.middle.text.createnew.title" | translate | async }}
    </h2>

    <app-loading></app-loading>

    @if((isLoading$ | async) === false)
      {
      <h3 class="h5">
        {{"calculator.type.category.0" | translate | async}}
      </h3>

      <ul>

        @for(worksheet of availableWorksheets; track worksheet.id)
          {
          @if(worksheet.displayCategory === 0)
            {
            <ng-container *ngTemplateOutlet="listItem; context: { worksheet: worksheet }"></ng-container>
          }
        }

      </ul>

      <h3 class="h5">
        {{"calculator.type.category.1" | translate | async}}
      </h3>

      <ul>

        @for(worksheet of availableWorksheets; track worksheet.id)
          {
          @if(worksheet.displayCategory === 1)
            {
            <ng-container *ngTemplateOutlet="listItem; context: { worksheet: worksheet }"></ng-container>
          }
        }

      </ul>

      <h3 class="h5">
        {{"calculator.type.category.2" | translate | async}}
      </h3>

      <ul>

        @for(worksheet of availableWorksheets; track worksheet.id)
          {
          @if(worksheet.displayCategory === 2)
            {
            <ng-container *ngTemplateOutlet="listItem; context: { worksheet: worksheet }"></ng-container>
          }
        }

      </ul>
    }
  </section>
  <section class="flex-child flex-child--align-top">
    <h2 class="h2">
      {{ "home.content.right.signin.title" | translate | async }}
    </h2>
    @if (!isAuthenticated) {
      <button type="button" mat-stroked-button class="button button--green-primary" (click)="login()">
        {{ "home.content.right.signin.button.caption" | translate | async }}
      </button>
    }
    <p>
      <a id="forgotPassword" href="javascript:void(0);" (click)="resetPassword()">
        {{ "home.content.right.text.forgotpassword" | translate | async }}
      </a>
    </p>
    <hr class="hr" />
    <h2 class="h2">
      {{ "home.content.right.text.getmost" | translate | async }}
    </h2>
    @if (!isAuthenticated) {
      <button type="button" mat-stroked-button class="button button--green-primary" (click)="signup()">
        {{ "home.content.right.createaccount.button.caption" | translate | async }}
      </button>
    }
    <p>
      {{ "home.content.right.text.createaccountallow" | translate | async }}
    </p>
    <ul>
      <li>
        {{ "home.content.right.text.securesave" | translate | async }}
      </li>
      <li>
        {{ "home.content.right.text.sharework" | translate | async }}
      </li>
      <li>
        {{ "home.content.right.text.accessinternet" | translate | async }}
      </li>
    </ul>
  </section>
</article>

<ng-template #listItem let-worksheet="worksheet">
  <li class="flex flex--cols-2">
    <p class="flex-child flex-child--flex-shrink">
      @if(requiresSignIn(worksheet))
        {
        <a (click)="login()" [tabIndex]="0" (keydown.enter)="login()" href="javascript:void(0);">
          {{ worksheet.description[lang$ | async] }} ({{ "calculator.requires.sign.in" | translate | async }})
        </a>
      }
      @else
      {
      <a (click)="navigateTo(worksheet.typeName)" [tabIndex]="0" (keydown.enter)="navigateTo(worksheet.typeName)"
        href="javascript:void(0);">
        {{ worksheet.description[lang$ | async] }}
      </a>
    }
  </p>

  <div class="flex-child flex-child--flex-shrink">
    <button type="button" class="button button--green-tertiary material-icons" [title]="worksheet.details[lang$ | async]" [tabindex]="0" (click)="toggleCardTooltip(tooltipLink)">
      info
    </button>
  </div>

  <div class="flex-child flex-child--full-width" #tooltipLink>
    {{ worksheet.details[lang$ | async] }}
  </div>
</li>
</ng-template>